import React, { useState } from 'react';
import { Typography, Card, Image, Row, Col,Button,Input } from 'antd';
import {  TEXT_CONSTANTS } from '../../constants/Constants';
import logBookImg from '../../assets/logbook.jpg'
import {  useNavigate } from 'react-router-dom';
import axios from 'axios';
import Password from 'antd/es/input/Password';


const LogBookLoginOutlet = () => {

  const Navigate=useNavigate();
  const { Title, Paragraph } = Typography;
const[emailId,setEmailId]=useState("")
const[password,setPassword]=useState("")
const redirect = new URLSearchParams(window.location.search).get('redirect');

const getAdminDetails = async (emailId, token) => {
  try {
    const res = await axios.get(`https://techsolutionsservice.ustdev.com/logbook/auth/adminDetails?emailId=${emailId}`, {
      headers: { 
        Authorization: `Bearer ${token}` 
      }
    });
    
    const adminData = res.data;
  
    localStorage.setItem("Name", adminData.name);
    localStorage.setItem("role", adminData.role);
    
      if(redirect){
        Navigate(`${redirect}`)
      }
      else{
        Navigate("/logbook/view-entries");
      }


    
    return adminData;
  } catch (error) {
    console.error("Unable to fetch admin details:", error);
    throw error;
  }
};

const handleLogin = async () => {
  const payload = {
    email: emailId,
    password: password
  };
  
  try {
    const response = await axios.post("https://techsolutionsservice.ustdev.com/logbook/auth/login", payload);
    console.log("Login successful:", response.data);
    
    const data = response.data;
    const token = data.token;
    
    localStorage.setItem("logbookToken", token);
    localStorage.setItem("emailId", emailId);

    await getAdminDetails(emailId, token);

    localStorage.setItem("isLogBookLoggedIn", true);
    
  } catch (error) {
    console.error("Login failed:", error);
    if (error.response?.status === 401) {
      alert("Invalid email or password");
    } else if (error.response?.status === 500) {
      alert("Server error. Please try again later.");
    } else {
      alert("Login failed. Please check your connection and try again.");
    }
  }
};

  return (
    <Row className="h-screen">
      {/* Left Section (Responsive) */}
      <Col xs={24} lg={10} className="bg-[#1F405A] p-8 h-screen flex flex-col justify-center gap-4">
        <div>
          <Title style={{color:"white"}} className="text-[40px] lg:text-[50px] text-white">
            Log Book
          </Title>
          <Paragraph className="text-white text-lg lg:text-xl">
            Log Book to manage user entry inside bay
          </Paragraph>
        </div>
        <div className="mt-auto flex justify-center">
          <Image
            src={logBookImg}
            alt={TEXT_CONSTANTS.IMAGE_ALT_TEXT}
            className="w-[200px] lg:w-[300px] h-auto"
            preview={false}

          />
        </div>
      </Col>

      {/* Right Section (Responsive) */}
      <Col xs={24} lg={14} className="bg-gray-100 h-screen flex items-center justify-center p-8">
        <Card
          className="w-full max-w-sm lg:max-w-md shadow-lg rounded-lg"
          style={{ textAlign: 'center' }}
        >
          <div className="flex flex-col items-center p-6">
        <Title level={2}>{"LOGBOOK LOGIN"} </Title>

        <Input
        type={'email'}
          placeholder="Email ID"
          value={emailId}
          onChange={(e) => setEmailId(e.target.value)}
          className="mb-3 p-2 border rounded w-full max-w-sm"
        />
        <Password
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="mb-3 p-2 border rounded w-full max-w-sm"
        />
        <Button
          className="w-1/2 p-2 Login-btn bg-blue-500 text-white hover:bg-blue-600 transition-colors mt-2"
          onClick={handleLogin}
        >
         Submit
        </Button>
      </div>
        </Card>
      </Col>
    </Row>
  );
};

export default LogBookLoginOutlet;


